import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy, useSortable, arrayMove } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { X, GripVertical } from "lucide-react";
import { mediaUrl } from "../lib/mediaUrl";

const SortableItem = ({ url, index, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: url });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 };
  return (
    <div ref={setNodeRef} style={style} className="relative group" data-testid={`my-portfolio-item-${index}`}>
      <img src={mediaUrl(url)} alt={`Portfolio ${index + 1}`} className="w-full h-24 sm:h-28 object-cover rounded-xl" />
      <button
        {...attributes}
        {...listeners}
        type="button"
        data-testid={`drag-portfolio-${index}`}
        className="absolute top-1.5 left-1.5 bg-midnight-black/80 text-clean-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity cursor-grab"
      >
        <GripVertical className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onRemove(url)}
        data-testid={`remove-portfolio-${index}`}
        className="absolute top-1.5 right-1.5 bg-midnight-black/80 text-clean-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

/** Drag-and-drop grid for a Photographer's own portfolio — order = display order on their public profile. */
export const SortablePortfolioGrid = ({ items, onReorder, onRemove }) => {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = items.indexOf(active.id);
    const newIndex = items.indexOf(over.id);
    onReorder(arrayMove(items, oldIndex, newIndex));
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items} strategy={rectSortingStrategy}>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4" data-testid="my-portfolio-grid">
          {items.map((url, i) => (
            <SortableItem key={url} url={url} index={i} onRemove={onRemove} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};
